// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__-_ekT"};